import { useState } from "react";

export default function Contact() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "General Inquiry",
    message: ""
  });

  const [status, setStatus] = useState({ type: null, message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: null, message: "" });

    try {

      const response = await fetch("https://formsubmit.co/ajax/Kpl@kplinfotech.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          _subject: `New Contact Form Inquiry: ${formData.subject}`,
          _captcha: "false"
        })
      });

      const result = await response.json();

      if (response.ok) {
        setStatus({
          type: "success",
          message: "Thank you! Your message has been sent successfully."
        });
        setFormData({
          name: "",
          email: "",
          subject: "General Inquiry",
          message: ""
        });
      } else {
        setStatus({
          type: "error",
          message: result.message || "Failed to send message. Please try again later."
        });
      }

    } catch (error) {

      console.log(error);
      setStatus({
        type: "error",
        message: "Unable to connect to FormSubmit. Please try again later."
      });

    } finally {
      setIsSubmitting(false);
    }
  };

  return(
    <div className="contact-page">
      
      {/* HEADER SECTION */}
      <div className="contact-hero">
        <span className="contact-eyebrow">Contact Details</span>
        <h1>Let's Start a Conversation</h1>
        <p>
          Have questions about our ERP systems, custom web projects, or industrial training? 
          Get in touch with us. Our team is ready to assist you.
        </p>
      </div>

      <div className="contact-container">
        <div className="contact-grid">

          {/* LEFT COLUMN: INFO CARDS & MAP */}
          <div className="contact-info">
            
            <div className="info-cards-grid">
              
              <div className="info-card">
                <div className="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="contact-icon">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </div>
                <div className="info-text">
                  <h3>Call Us</h3>
                  <a href="tel:+919876543210" className="info-link">+91 98765 43210</a>
                  <span>Mon-Sat (9:00 AM - 6:00 PM)</span>
                </div>
              </div>

              <div className="info-card">
                <div className="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="contact-icon">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div className="info-text">
                  <h3>Email Us</h3>
                  <a href="mailto:kpl@kplinfotech.com" className="info-link">kpl@kplinfotech.com</a>
                  <span>Replies within 24 hours</span>
                </div>
              </div>

              <div className="info-card">
                <div className="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="contact-icon">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div className="info-text">
                  <h3>Our Office</h3>
                  <p className="info-val">Delhi, India</p>
                  <span>Main Tech Hub, Block B</span>
                </div>
              </div>

              <div className="info-card">
                <div className="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="contact-icon">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                </div>
                <div className="info-text">
                  <h3>Working Hours</h3>
                  <p className="info-val">Mon - Sat: 9:00 AM - 6:00 PM</p>
                  <span>Sunday: Closed</span>
                </div>
              </div>

            </div>

            {/* MAP WRAPPER */}
            <div className="map-container">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1m4!2s0x390cfd5b347eb62d%3A0xa549f3e9c20a13ef!2sDelhi!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
                width="100%" 
                height="290" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="KPL Infotech Office Location"
              ></iframe>
            </div>

            {/* SOCIAL CONNECTIONS */}
            <div className="social-connect-block">
              <h4>Follow KPL Infotech</h4>
              <div className="social-links-grid">
                <a href="#linkedin" className="social-item" aria-label="LinkedIn">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-svg">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                    <rect x="2" y="9" width="4" height="12"/>
                    <circle cx="4" cy="4" r="2"/>
                  </svg>
                </a>
                <a href="#twitter" className="social-item" aria-label="Twitter">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-svg">
                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
                  </svg>
                </a>
                <a href="#github" className="social-item" aria-label="GitHub">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-svg">
                    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/>
                  </svg>
                </a>
              </div>
            </div>

          </div>

          {/* RIGHT COLUMN: MODERN FORM CARD */}
          <div className="contact-form-wrapper">
            <div className="contact-card-form">
              
              <h2>Send Us a Message</h2>
              <p className="form-lead">Have an idea or a query? Fill out the form, and we'll reply shortly.</p>

              {status.type && (
                <div className={`form-alert alert-${status.type}`}>
                  <div className="alert-content-wrapper">
                    {status.type === "success" ? (
                      <svg className="alert-svg-icon text-success" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" stroke="currentColor"/>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4"/>
                      </svg>
                    ) : (
                      <svg className="alert-svg-icon text-error" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" stroke="currentColor"/>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                      </svg>
                    )}
                    <span className="alert-text">{status.message}</span>
                  </div>
                  <button type="button" className="alert-dismiss-btn" onClick={() => setStatus({ type: null, message: "" })} aria-label="Dismiss alert">×</button>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                
                <div className="field-group">
                  <label htmlFor="name" className="field-label">Full Name</label>
                  <div className="input-icon-container">
                    <svg className="field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="e.g. John Doe"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="field-group">
                  <label htmlFor="email" className="field-label">Email Address</label>
                  <div className="input-icon-container">
                    <svg className="field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="e.g. john@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="field-group">
                  <label htmlFor="subject" className="field-label">Inquiry Type</label>
                  <div className="input-icon-container">
                    <svg className="field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                      <line x1="8" y1="21" x2="16" y2="21"/>
                      <line x1="12" y1="17" x2="12" y2="21"/>
                    </svg>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    >
                      <option value="General Inquiry">General Inquiry</option>
                      <option value="ERP Solutions">ERP Solutions</option>
                      <option value="Web Development">Web Development</option>
                      <option value="Industrial Training">Industrial Training</option>
                    </select>
                  </div>
                </div>

                <div className="field-group">
                  <label htmlFor="message" className="field-label">Your Message</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Tell us how we can help your business or learning goals..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="contact-submit-btn" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <span className="spinner-align">
                      <span className="mini-spinner"></span>
                      Sending Message...
                    </span>
                  ) : (
                    <span>Send Message</span>
                  )}
                </button>

              </form>

            </div>
          </div>

        </div>
      </div>

    </div>
  );
}